module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part",
    attrs: {
      "id": "pt01"
    }
  }, [_c('div', {
    staticClass: "partHead",
    attrs: {
      "id": "ph01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page03"
    }
  }, [_c('h2', {
    staticClass: "partNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("I")])]), _vm._v(" "), _c('div', {
    staticClass: "partEpigraph"
  }, [_c('p', {
    staticClass: "partEpigraphText"
  }, [_vm._v("Behold! Exalted, I nave come. I have escaped from the nether world. The roads of the earth and of the sky are open before me.")]), _vm._v(" "), _c('p', {
    staticClass: "partEpigraphSource"
  }, [_vm._v("The Book of the Dead, 78")])])])]), _c('a', {
    attrs: {
      "id": "page03"
    }
  }, [_c('div', {
    staticClass: "partBody"
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page03"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f7a6385","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/futureindefinite_pt01.vue
// module id = 90
// module chunks = 0